var $ = require('jquery');
var _ = require('lodash');

var _module = require('../../components/module');

require('angular-ui-bootstrap/src/modal');
require('../lr-touch');
require('../search-results-utils');
require('../../components/window-height');
require('../../components/third-party/angular-slick');

_module.requires.push('ui.bootstrap.module.modal', 'slickCarousel');

_module.service('$fscarousel', [
    '$log',
    '$uibModal',
    '$timeout',
    '$window',
    'srUtils',

    function $fscarouselService($log, $uibModal, $timeout, $window, srUtils) {
        /*
        @function openFsCarouselModal
        */
        return function openFsCarouselModal(list, currIndex) {
            var modal = $uibModal.open({
                template: require('./index.html'),
                controller: ['$scope', function fsCarouselModalCtrl($scope) {
                    var initLayout = function initLayout() {
                        $scope.layout = {
                            w: $window.innerWidth,
                            h: $window.innerHeight
                        };
                    };

                    var initSlickConfig = function () {
                        $scope.disableAnimation = !srUtils.isMobile();
                        $scope.currentIndex = (!isNaN(currIndex)) ? parseInt(currIndex, 10) : 0;
                        $scope.slickConfig = {
                            method: {},
                            event: {
                                afterChange: function (event, slick, currentSlide, nextSlide) {
                                    $timeout(function () {
                                        $scope.currentIndex = currentSlide; // save current index each time
                                    });
                                },
                                init: function (event, slick) {
                                    $timeout(function () {
                                        slick.slickGoTo($scope.currentIndex, true); // slide to correct index when init
                                    });
                                }
                            }
                        };
                    };

                    var initList = function initList(list) {
                        $scope.list = JSON.parse(JSON.stringify(list));
                    };

                    var init = function init() {
                        initLayout();
                        initSlickConfig();
                        initList(list);
                    };

                    init();

                    /// PUBLIC FUNCTIONS

                    $scope.closeModal = function closeModal() {
                        if($scope.currentIndex) {
                            try {
                                $scope.$close($scope.currentIndex);
                            } catch (err) {
                                $scope.$dismiss();
                                $log.debug('Error trying to close fscarousel modal', err);
                            }
                        }else {
                            $scope.$dismiss();
                        }
                    };


                    /// EVENT HANDLERS

                    $(window).on('resize.fscarousel', _.debounce(function (ev){
                        $log.debug('Resize happened', ev);
                        $timeout(function () {
                            initLayout();
                            // we reset the slick slide to the currentIndex
                            // to ensure proper positioning on window resize
                            $scope.slickConfig.method.slickGoTo($scope.currentIndex || 0, $scope.disableAnimation);
                        });
                    },100));


                    $scope.$on('$destroy',function (){
                        $(window).off('resize.fscarousel'); //remove the handler added earlier
                    });
                }],
                backdrop: 'static',
                keyboard: false,
                windowClass: 'fullscreen-carousel-modal'
            });

            return modal.result;
        };
    }
]);
